<template>
    <v-row class="fill-height" no-gutters>
        <v-col cols="8" class="fill-height">
            <ag-grid-vue style="width: 100%; height: 100%;"
                         :columnDefs="columnDefs"
                         @grid-ready="onGridReady"
                         :defaultColDef="defaultColDef"
                         :rowClassRules="rowClassRules"
                         :rowData="rowData"
                         :rowDragManaged="true"
                         :animateRows="true"
                         :theme="theme">
            </ag-grid-vue>
        </v-col>
        <v-col cols="4" class="fill-height pa-2" v-on:dragover="onDragOver($event)" v-on:drop="onDrop($event)">
            <v-sheet class="fill-height pa-4 d-flex flex-column" border rounded>
                <span id="eDropTarget">
                    ==&gt; Drop to here
                </span>
                <div id="eJsonDisplay">
                </div>
            </v-sheet>
        </v-col>
    </v-row>
</template>

<script setup>
    import { ref } from 'vue';
    import { AgGridVue } from "ag-grid-vue3";
    import { ModuleRegistry, ValidationModule, ClientSideRowModelModule, RowDragModule, RowStyleModule, ColumnApiModule, RenderApiModule, CellApiModule } from 'ag-grid-enterprise';
    import { DragAndDropModule, themeMaterial } from "ag-grid-community";

    ModuleRegistry.registerModules([ValidationModule, ClientSideRowModelModule, RowDragModule, DragAndDropModule, RowStyleModule, ColumnApiModule, RenderApiModule, CellApiModule]);

    const columnDefs = [
        { valueGetter: "'Drag'", dndSource: true },
        { field: 'id' },
        { field: 'color' },
        { field: 'value1' },
        { field: 'value2' },
    ];
    const gridApi = ref(null);
    const columnApi = ref(null);
    const defaultColDef = {
        width: 80,
        sortable: true,
        filter: true,
        resizable: true,
    };
    const rowClassRules = ref(null);
    const rowData = ref(null);
    const theme = themeMaterial;

    //#region created()
        rowClassRules.value = {
            'red-row': 'data.color == "Red"',
            'green-row': 'data.color == "Green"',
            'blue-row': 'data.color == "Blue"',
        };
    //endregion

    function onDragOver(event) {
        var dragSupported = event.dataTransfer.length;
        if (dragSupported) {
            event.dataTransfer.dropEffect = 'move';
        }
        event.preventDefault();
    }

    function onDrop(event) {
        var jsonData = event.dataTransfer.getData('application/json');
        var eJsonRow = document.createElement('div');
        eJsonRow.innerText = jsonData;
        var eJsonDisplay = document.querySelector('#eJsonDisplay');
        eJsonDisplay.appendChild(eJsonRow);
        event.preventDefault();
    }

    function onGridReady(params) {
        gridApi.value = params.api;
        columnApi.value = params.columnApi;

        var rowIdSequence = 0;

        var data = [];
        [
            'Red',
            'Green',
            'Blue',
            'Red',
            'Green',
            'Blue',
            'Red',
            'Green',
            'Blue',
        ].forEach(function (color) {
            var newDataItem = {
                id: rowIdSequence++,
                color: color,
                value1: Math.floor(Math.random() * 100),
                value2: Math.floor(Math.random() * 100),
            };
            data.push(newDataItem);
        });

        rowData.value = data;
    }
</script>
